const routes = [
  { icon: "home", name: "Home", route: "/",routeName:"home" },
  { icon: "school", name: "Courses", route: "/courses",routeName:"courses"  },
  { icon: "event", name: "News & Events", route: "/news" ,routeName:"news" },
  // { icon: "help", name: "How It Works", route: "/how-it-works",routeName:"how-it-works"  },
  // { icon: "book", name: "Blog", route: "/blog" ,routeName:"blog" },
  { icon: "help", name: "FAQs", route: "/faqs",routeName:"faqs"  },
  { icon: "email", name: "Contact Us", route: "/contact-us",routeName:"contact-us"  },
  // { icon: "login", name: "Sign In", route: "/#", external: true },
  // { icon: "search", name: "Search", route: "/search" }, // Search route
  // { icon: "arrow_forward", name: "Sign Up", route: "/register" },
];
export default routes;
